<xpo-filter-container>
  <!-- <xpo-select-opt-group [options]="configuration.options$ | async" [selection]="selection" (selectionChange)="optionsSelected($event)">
  </xpo-select-opt-group> -->
</xpo-filter-container>
